<template>
  <div
    :class="{ flex: !vertical, ...nameClass }"
    class="flex items-center border border-black rounded-lg"
    style="background-color: #8A8A8A"
  >
    <div :class="{ 'w-5/12': !vertical }" class="p-2">
      <span class="self-center text-xl font-bold text-white">{{ name }}</span>
    </div>
    <div :class="{ 'w-7/12': !vertical }" class="flex p-2">
      <p :class="valueClass" class="flex-1 p-2 font-bold tracking-tight text-blue-800 bg-white rounded-lg">
        {{ value }}
      </p>
      <span v-if="extra" class="flex-none px-4">{{ extra }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JGItemCell',
  props: {
    name: {
      type: String,
      required: true,
    },
    nameClass: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    value: {
      type: [String, Number, undefined],
      required: true,
    },
    valueClass: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    extra: {
      type: String,
      required: false,
      default: null,
    },
    vertical: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
